import Vue from 'vue';
import _ from "lodash";
import { ADD_TOAST_MESSAGE } from "vuex-toast";
import i18n from '../../i18n';
import stockAPI from "../api/stock";
import userAPI from "../api/user";
import exportAPI from "../api/export"

const types = {
  LOADING: 'LOADING',
  SET_FIELD: 'SET_FIELD',
  SET_SORT_FIELD: 'SET_SORT_FIELD',
  LOADING_BY_KEY: "LOADING_BY_KEY",
  GET_INFO_SUCCESS: 'GET_INFO_SUCCESS',
  GET_INFO_FAIL: 'GET_INFO_FAIL',
  GET_SHAREHOLDERS_OK: 'GET_SHAREHOLDERS_OK',
  GET_INFO_OUT_OF_LICENSE: 'GET_INFO_OUT_OF_LICENSE',
  ACTION_WATCH_LIST_SUCCESS: 'ACTION_WATCH_LIST_SUCCESS',
  GET_WATCH_LIST_SUCCESS: 'GET_WATCH_LIST_SUCCESS',
  GET_STOCK_SAME_INDUSTRY_SUCCESS: 'GET_STOCK_SAME_INDUSTRY_SUCCESS',
  GET_STOCK_SAME_INDUSTRY_FAIL: 'GET_STOCK_SAME_INDUSTRY_FAIL',
  GET_REQUESTS_OK: 'GET_REQUESTS_OK',
  GET_REQUESTS_FAILED: 'GET_REQUESTS_FAILED',
  GET_OVERVIEW_OK: 'GET_OVERVIEW_OK',
  ACTION_REQUEST_OK: 'ACTION_REQUEST_OK',
  NO_DATA: 'NO_DATA'
};

// initial state
const initalState = {
  form: {},
  sort: {
    field : "mos",
    order : "desc"
  },
  ratios: {},
  item: {},
  industry: {},
  watchlist: {},
  requests: {},
  loading: false,
  summary: {}
};

// getters
const getters = {
  form: state => state.form,
  sort: state => state.sort,
  loading: state => state.loading,
  item: state => state.item,
  shareholders : state => state.shareholders,
  industry: state => state.industry,
  watchlist: state => state.watchlist,
  requests: state => state.requests,
  summary: state => state.summary,
  ratios: state => state.ratios,
};

// actions
const actions = {
  setField({ commit }, { key, value }) {
    commit(types.SET_FIELD, { key, value });
  },

  setSortField({ commit }, { key, value }) {
    commit(types.SET_SORT_FIELD, { key, value });
  },

  async getOverview({ commit, dispatch }, code) {
    try {
      commit('LOADING_BY_KEY', { key: "overviewLoading", status: true });
      const { data } = await stockAPI(dispatch).getOverview(code);
      commit(types.GET_OVERVIEW_OK, data);
    } catch (e) {
      commit(types.GET_REQUESTS_FAILED, code);
      commit('LOADING_BY_KEY', { key: "overviewLoading", status: false });
    }
  },

  async getShareholders({ commit, dispatch }, code) {
    try {
      commit('LOADING_BY_KEY', { key: "getShareholderLoading", status: true });
      const { data } = await stockAPI(dispatch).getShareholders(code);
      commit(types.GET_SHAREHOLDERS_OK, data);
    } catch (e) {
      Vue.$log.error(i18n.t('messages.get_shareholders_failed'), e);
      commit('LOADING_BY_KEY', { key: "getShareholderLoading", status: false });
    }
  },

  async getRequests({ commit, dispatch }) {
    try {
      commit('LOADING_BY_KEY', { key: "requestsLoading", status: true });
      const { data } = await stockAPI(dispatch).getRequests();
      commit(types.GET_REQUESTS_OK, data);
    } catch (e) {
      Vue.$log.error(i18n.t('messages.request_stock_failed'), e);
      commit(types.GET_REQUESTS_FAILED, code);
      commit('LOADING_BY_KEY', { key: "requestsLoading", status: false });
    }
  },

  async removeRequest({ commit, dispatch }, requestId) {
    try {
      commit('LOADING_BY_KEY', { key: "requestsLoading", status: true });
      await stockAPI(dispatch).removeRequest(requestId);
      dispatch("getRequests");
      commit(types.ACTION_REQUEST_OK, false);
      if (data && data.code > 400000) {
        dispatch(
          ADD_TOAST_MESSAGE,
          {
            text: i18n.t(`errors.${data.code}`),
            type: "danger"
          },
          { root: true }
        );
      }
    } catch (e) {
      Vue.$log.error(i18n.t('messages.request_remove_failed'), e);
      commit('LOADING_BY_KEY', { key: "requestsLoading", status: false });
    }
  },

  async requestNewStock({ commit, dispatch }, code) {
    try {
      commit('LOADING_BY_KEY', { key: "requestsLoading", status: true });
      const { data } = await stockAPI(dispatch).requestNewStock(code);
      dispatch("getRequests");
      commit(types.ACTION_REQUEST_OK, false);
      if (data && data.code === 200) {
        dispatch(
          ADD_TOAST_MESSAGE,
          {
            text: i18n.t('messages.request_stock_ok'),
            type: "success"
          },
          { root: true }
        );
      } else {
        dispatch(
          ADD_TOAST_MESSAGE,
          {
            text: i18n.t(`errors.${data.code}`),
            type: "danger"
          },
          { root: true }
        );
      }
    } catch (e) {
      Vue.$log.error(i18n.t('messages.request_stock_failed'), e);
      commit('LOADING_BY_KEY', { key: "requestsLoading", status: false });
    }
  },

  async exportToFile({ commit, dispatch }, code) {
    try {
      console.log(response)
      const response = await exportAPI(dispatch).exportToFile(code);
      
    } catch (e) {
      Vue.$log.error("Download statements failed: ", e);
    }
  },

  async getStockInfo({ commit, dispatch }, code) {
    try {
      commit('LOADING_BY_KEY', { key: "stockInfoLoading", status: true });
      const { data } = await stockAPI(dispatch).getStockInfo(code);
      if (data) {
        if (data.code === 403001) {
          commit(types.GET_INFO_OUT_OF_LICENSE);
        } else if (data.code === 400099) {
          commit(types.NO_DATA);
        } else {
          commit(types.GET_INFO_SUCCESS, data);
        }
      } else {
        commit(types.GET_INFO_FAIL, code);
        commit('LOADING_BY_KEY', { key: "stockInfoLoading", status: false });
      }
    } catch (e) {
      Vue.$log.error("Get stock info fail", e);
      commit(types.GET_INFO_FAIL, code);
      commit('LOADING_BY_KEY', { key: "stockInfoLoading", status: false });
    }
  },
  
  async getStockSameIndustry({ commit, dispatch }, code) {
    try {
      commit('LOADING_BY_KEY', { key: "stockIndustryLoading", status: true });
      const { data } = await stockAPI(dispatch).getStockSameIndustry(code);
      commit(types.GET_STOCK_SAME_INDUSTRY_SUCCESS, data);
    } catch (e) {
      Vue.$log.error("Get stock same sector fail", e);
      commit(types.GET_STOCK_SAME_INDUSTRY_FAIL);
      commit('LOADING_BY_KEY', { key: "stockIndustryLoading", status: false });
    }
  },

  async getStockSameIndustryV2({state, commit, dispatch }, code) {
    try {
      commit('LOADING_BY_KEY', { key: "stockIndustryLoading", status: true });
      const formData = {
        "search" : "",
        "sort" : state.sort,
        "page" : 1,
        "limit" : 50
      };
      const { data } = await stockAPI(dispatch).getStockSameIndustryV2(code, formData);
      if (data) {
        commit(types.GET_STOCK_SAME_INDUSTRY_SUCCESS, data.items);
      } else {
        commit(types.GET_STOCK_SAME_INDUSTRY_FAIL);
      }
      
    } catch (e) {
      Vue.$log.error("Get stock same sector fail", e);
      commit(types.GET_STOCK_SAME_INDUSTRY_FAIL);
      commit('LOADING_BY_KEY', { key: "stockIndustryLoading", status: false });
    }
  },

  async onAddToWatchlist({ commit, dispatch }, params) {
    try {
      let code = params.code;
      if (code) {
        commit('LOADING_BY_KEY', { key: "stockWatchlistLoading", status: true });
        const formData = {
          codes: [code]
        };
        await userAPI(dispatch).onAddToWatchlist(formData);
        if (params.page === 'overview') {
          dispatch('getOverview', code);
        }
        dispatch(
          ADD_TOAST_MESSAGE,
          {
            text: i18n.t('messages.watchlist_add_ok'),
            type: "success"
          },
          { root: true }
        );
        commit(types.ACTION_WATCH_LIST_SUCCESS, true);
      } else {
        dispatch(
          ADD_TOAST_MESSAGE,
          {
            text: "Symbol could not be empty",
            type: "danger"
          },
          { root: true }
        );
      }
    } catch (e) {
      Vue.$log.error(i18n.t('messages.watchlist_add_failed'), e);
      commit('LOADING_BY_KEY', { key: "stockWatchlistLoading", status: false });
    }
  },

  async onRemoveWatchlist({ commit, dispatch }, params) {
    try {
      commit('LOADING_BY_KEY', { key: "stockWatchlistLoading", status: true });
      const formData = {
        codes: [params.code]
      };
      await userAPI(dispatch).onRemoveWatchlist(formData);
      if (params.page === 'overview') {
        dispatch("getOverview", params.code);
      } else {
        dispatch("getWatchlist");
      }
      dispatch(
        ADD_TOAST_MESSAGE,
        {
          text: i18n.t('messages.watchlist_remove_ok'),
          type: "success"
        },
        { root: true }
      );
      commit(types.ACTION_WATCH_LIST_SUCCESS, false);
    } catch (e) {
      Vue.$log.error(i18n.t('messages.watchlist_remove_failed'), e);
      commit('LOADING_BY_KEY', { key: "stockWatchlistLoading", status: false });
    }
  },
};

// mutations
const mutations = {
  [types.SET_FIELD](state, params) {
    Vue.set(state.form, params.key, params.value);
  },

  [types.SET_SORT_FIELD](state, params) {
    Vue.set(state.sort, params.key, params.value);
  },

  [types.GET_OVERVIEW_OK](state, data) {
    Vue.set(state, 'summary', data);
    Vue.set(state.form, 'overviewLoading', false);
  },

  [types.GET_SHAREHOLDERS_OK](state, data) {
    Vue.set(state, 'shareholders', data);
    Vue.set(state.form, 'getShareholderLoading', false);
  },

  [types.GET_REQUESTS_OK](state, data) {
    Vue.set(state, 'requests', data);
    Vue.set(state.form, 'requestsLoading', false);
  },

  [types.GET_REQUESTS_FAILED](state) {
    Vue.set(state, 'requests', {});
  },

  [types.ACTION_REQUEST_OK](state, data) {
    Vue.set(state.item, 'requests', data);
    Vue.set(state.form, 'requestLoading', false);
  },

  [types.GET_INFO_SUCCESS](state, data) {
    Vue.set(state, 'item', data);
    Vue.set(state, 'ratios', data);
    Vue.set(state.form, 'hasData', true);
    Vue.set(state.form, 'stockInfoLoading', false);
    Vue.set(state.form, 'stockOOLicense', false);
  },

  [types.GET_INFO_OUT_OF_LICENSE](state) {
    Vue.set(state, 'item', {});
    Vue.set(state.form, 'stockOOLicense', true);
    Vue.set(state.form, 'stockInfoLoading', false);
  },
  
  [types.NO_DATA](state) {
    Vue.set(state, 'item', {});
    Vue.set(state.form, 'hasData', false);
    Vue.set(state.form, 'stockInfoLoading', false);
  },

  [types.GET_STOCK_SAME_INDUSTRY_SUCCESS](state, data) {
    Vue.set(state, 'industry', data);
    Vue.set(state.form, 'stockIndustryLoading', false);
  },

  [types.GET_WATCH_LIST_SUCCESS](state, data) {
    Vue.set(state, 'watchlist', data);
    Vue.set(state.form, 'watchlistLoading', false);
  },

  [types.ACTION_WATCH_LIST_SUCCESS](state, data) {
    Vue.set(state.item, 'favorite', data);
    Vue.set(state.form, 'stockWatchlistLoading', false);
  },

  [types.GET_INFO_FAIL](state, code) {
    Vue.set(state, 'item', {});
    Vue.set(state, 'codeValue', false);
    Vue.set(state.form, 'stockInfoLoading', false);
  },

  [types.GET_STOCK_SAME_INDUSTRY_FAIL](state) {
    Vue.set(state, 'industry', {});
    Vue.set(state.form, 'stockIndustryLoading', false);
  },

  [types.LOADING](state, loading) {
    Vue.set(state, 'loading', loading);
  },

  [types.LOADING_BY_KEY](state, data) {
    Vue.set(state.form, data.key, data.status);
  },
};

export default {
  namespaced: true,
  state: initalState,
  getters,
  actions,
  mutations,
};
